import { useQuery } from 'react-query';

import { KimMessageArtifact } from '../../../../backend/src/matter/subset/thread/kim-message-artifact.entity';
import { APIBaseChronos } from '@/api/hosts';
import { ApiError, QueryEntity } from '@/api/types';
import useGetFetchConfig from '@/api/useGetFetchConfig';

export const useGetMyKimArtifacts = (matterId?: string, subsetId?: string) => {
  const { fetchConfigGET } = useGetFetchConfig();

  return useQuery<KimMessageArtifact[], ApiError>(
    [QueryEntity.KimArtifacts, { subsetId }],
    async () => {
      const res = await fetch(
        `${APIBaseChronos}/api/matter/${matterId}/subset/${subsetId}/kim/artifacts`,
        fetchConfigGET,
      );
      if (!res.ok) {
        const error = await res.json();
        throw new ApiError(error.code, error.message);
      }
      return res.json();
    },
    {
      enabled: !!matterId && !!subsetId,
      refetchOnWindowFocus: false,
    },
  );
};

export const useGetPublishedKimArtifacts = (matterId?: string, subsetId?: string) => {
  const { fetchConfigGET } = useGetFetchConfig();

  return useQuery<KimMessageArtifact[], ApiError>(
    [QueryEntity.KimPublishedArtifacts, { subsetId }],
    async () => {
      const res = await fetch(
        `${APIBaseChronos}/api/matter/${matterId}/subset/${subsetId}/kim/artifacts/published`,
        fetchConfigGET,
      );
      if (!res.ok) {
        const error = await res.json();
        throw new ApiError(error.code, error.message);
      }
      return res.json();
    },
    {
      enabled: !!matterId && !!subsetId,
      refetchOnWindowFocus: false,
    },
  );
};
